import BaseComponent from './BaseComponent';

class DropdownLanguages extends BaseComponent {
  constructor(componentName){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    const navbar = document.getElementsByClassName('navbar')[0];
    const navDropdown = document.getElementsByClassName('dropdown-list')[0];
    component.element.addEventListener('mouseover', (e) => {
      if(!!navbar) navbar.classList.add('dropdown-opened');
      if(!!navDropdown) navDropdown.classList.remove('visible');
    });

    component.element.addEventListener('mouseout', (e) => {
      if(!!navbar) navbar.classList.remove('dropdown-opened');
    });
  }
}

export default DropdownLanguages;
